import type { Ref } from 'vue'
import { ref, watch } from 'vue'

export default function useFixedDimensions(
  isRefreshing: Ref<boolean>,
  htmlElement: Ref<HTMLElement | null>,
  options: { fixWidth?: boolean, fixHeight?: boolean } = { fixWidth: true, fixHeight: true }
): { elementWidth: Ref<string | null>, elementHeight: Ref<string | null> } {
  const elementWidth: Ref<string | null> = ref(null)
  const elementHeight: Ref<string | null> = ref(null)

  watch(isRefreshing, () => {
    if (!isRefreshing.value || !htmlElement.value) {
      elementWidth.value = null
      elementHeight.value = null
      return
    }
    const rect = htmlElement.value.getBoundingClientRect()
    if (options.fixWidth) {
      elementWidth.value = `${rect.width}px`
    }

    if (options.fixHeight) {
      elementHeight.value = `${rect.height}px`
    }
  })

  return { elementWidth, elementHeight }
}
